import { render, staticRenderFns } from "./realWarehouse.vue?vue&type=template&id=5c5fa247&scoped=true"
import script from "./realWarehouse.vue?vue&type=script&lang=js"
export * from "./realWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fa247",
  null
  
)

export default component.exports